// 从md中提取元数据
//
// 在md中，例如：
//   [//]: # (title:用户指南)
//   [//]: # (direction:rtl)
//   ...
//   会被转换为 {title: '用户指南', direction: 'rtl'}
export const getMeta = (str: string) => {
  const regex = /^(\[\/\/\]: # \(=?)(.*)(?=\)\n)/gm;
  const meta: { [prop: string]: string } = {};
  let arr;

  while ((arr = regex.exec(str)) !== null) {
    const match = arr[2].split(':');
    meta[match[0]?.trim()] = match[1]?.trim();
  }

  return meta;
};
